import React from 'react';
import { useFormState } from 'react-final-form';

import WpButton from 'Wpds/components/button/WpButton';
import WpButtonGroup from 'Wpds/components/button/WpButtonGroup';

type Props = {
  onSubmit(): void;
  onToggleModal(): void;
};

function ButtonsArea({ onSubmit, onToggleModal }: Props) {
  const { submitting, errors } = useFormState();

  const errorsExist = !!Object.keys(errors).filter(key => errors[key]).length;

  return (
    <WpButtonGroup>
      <WpButton variant="tertiary" disabled={submitting} onClick={onToggleModal}>
        Cancel
      </WpButton>

      <WpButton btnType="submit" loading={submitting} disabled={errorsExist} onClick={onSubmit}>
        Create
      </WpButton>
    </WpButtonGroup>
  );
}

export default ButtonsArea;
